import React from "react";
import { Layout } from "react-admin";
// Local
import { AppMenu } from "./AppMenu";

export function AppLayout(props) {
  return <Layout {...props} menu={AppMenu} />;
}
